import Promise from 'promise';
import type { Dispatch } from 'redux';

import api from 'app/shared/utils/api';
import constants from 'app/shared/constants/ConstantsBundle';
import { getGlobalLogger } from '@zg-rentals/logger-base';
import { logError } from '@zg-rentals/log-error';

const logger = getGlobalLogger('actions/notification');

type ApiResult = {
  data: unknown;
  [key: string]: unknown;
};

type CancelSearchesParams = {
  cancelHash?: string;
  email?: string;
  cancelSavedSearch?: boolean;
};

type UpdateSearchFrequencyParams = {
  email?: string;
  frequency?: string;
  hash?: string;
  searchId?: string;
};

type TrackNotificationParams = {
  notificationId?: string;
  type?: string;
  ref?: string;
};

const NotificationActions = {
  email: {
    getUserSubscriptions(email: string) {
      return function (dispatch: Dispatch) {
        if (email) {
          // @ts-expect-error - api types not yet defined
          return dispatch(api.user.email.subscriptions(email)).then((result: ApiResult) => {
            dispatch({
              type: constants.USER_LOAD_SUBSCRIPTIONS,
              payload: result.data,
            });
            return result;
          });
        } else {
          return Promise.resolve({});
        }
      };
    },
    updateUserSubscriptions(subscriptions: unknown, email: string) {
      return function (dispatch: Dispatch) {
        // @ts-expect-error - api types not yet defined
        return dispatch(api.user.email.unsubscribe(subscriptions, email)).then((result: ApiResult) => {
          dispatch({
            type: constants.USER_LOAD_SUBSCRIPTIONS,
            payload: result.data,
          });
          return result;
        });
      };
    },
    cancelSearches({ cancelHash, email, cancelSavedSearch }: CancelSearchesParams = {}) {
      return function (dispatch: Dispatch) {
        // @ts-expect-error - api types not yet defined
        return dispatch(api.user.email.cancelSearches(cancelHash, email, cancelSavedSearch));
      };
    },
    updateSearchFrequency({ email, frequency, hash, searchId }: UpdateSearchFrequencyParams = {}) {
      return function (dispatch: Dispatch) {
        // @ts-expect-error - api types not yet defined
        return dispatch(api.user.email.updateSearchFrequency(email, frequency, hash, searchId));
      };
    },
    updateEmailOptIn(emailOptIn: boolean, emailOptInSource: string) {
      return function (dispatch: Dispatch) {
        dispatch({
          type: constants.USER_UPDATE_EMAIL_OPT_IN,
        });

        // @ts-expect-error - api types not yet defined
        return dispatch(api.user.email.updateEmailOptIn(emailOptIn, emailOptInSource));
      };
    },
  },
  notifications: {
    track({ notificationId, type, ref }: TrackNotificationParams = {}) {
      return function (dispatch: Dispatch) {
        if (!notificationId) {
          logger?.warn('NotificationActions#track#notification No notificationId provided');
          return;
        }

        return dispatch(
          // @ts-expect-error - api types not yet defined
          api.notifications.track({
            notificationId,
            type,
            ref: ref || 'BROWSER',
          }),
        );
      };
    },
    updateSettings(options: unknown) {
      return function (dispatch: Dispatch) {
        // @ts-expect-error - api types not yet defined
        return dispatch(api.notifications.update(options));
      };
    },
    getSettings() {
      return function (dispatch: Dispatch) {
        // @ts-expect-error - api types not yet defined
        return dispatch(api.notifications.getAll())
          .then((response: ApiResult) => {
            if (response && response.data) {
              return dispatch({
                type: constants.SET_NOTIFICATION_SETTINGS,
                payload: response.data,
              });
            }
            return undefined;
          })
          .catch((err: Error) => {
            logError({
              error: err,
              errorType: 'NotificationActionsError',
              context: 'Error getting user notification settings',
            });
            return false;
          });
      };
    },
  },
};

export default NotificationActions;
